import React from 'react';
import { atom } from '@reatom/framework';
import { createSpyContext } from './context';
/**
 * @param map
 * @param deps
 * @deprecated use useMapped$ instead
 */
export function useMappedObservable(map, deps) {
    return React.useMemo(() => ({
        __INTERNAL_DO_NOT_USE_ATOM__: atom((ctx) => map(createSpyContext(ctx))),
    }), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    deps ?? []);
}
